<template>
  <div v-if="serviceJsonState?.isReady" v-show="serviceJsonState?.isShown">
    <json-viewer
      data-cy="json-viewer"
      :data="data"
      :update-service-json-payload="updateServiceJsonPayload"
      :provider-name="providerName"
    />
  </div>
</template>
<script setup lang="ts">
import { computed, provide } from "vue";

import { serviceName as name, serviceType as type } from "@/helpers/symbols";
import { getAsyncComponent } from "@/hooks/common";
import { useJsonTreeStateStore } from "@/stores/serviceJsonViewer";

import type { UpdateServiceJsonPayload } from "@/models/applications";
import type { JsonViewerData } from "@/models/jsonViewer";
import type { PropType } from "vue";

const JsonViewer = getAsyncComponent(
  () => import("@/components/deals/dataServices/jsonViewer/JsonViewer.vue")
);

const props = defineProps({
  data: {
    type: Object as PropType<JsonViewerData | null>,
    required: true,
  },
  providerName: {
    type: String,
    required: true,
  },
  serviceName: {
    type: String,
    required: true,
  },
  serviceType: {
    type: String,
    required: true,
  },
  updateServiceJsonPayload: {
    type: Object as PropType<Omit<UpdateServiceJsonPayload, "content">>,
  },
});

const jsonTreeStateStore = useJsonTreeStateStore();

provide(name, props.serviceName);
provide(type, props.serviceType);

const serviceJsonState = computed(
  () =>
    jsonTreeStateStore.servicesJsonStatuses[
      props.providerName as keyof typeof jsonTreeStateStore.servicesJsonStatuses
    ]
);
</script>
